import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBarIcons from "./TopBarIcons";
import "../css/requisition-app-styles.css";
import PopupModal from "./PopupModal";  
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import LoadingOverlay from "./LoadingOverlay";
import { faWifi } from '@fortawesome/free-solid-svg-icons';
import ConfirmModal from "./ConfirmModal"; 
import { faTrash } from "@fortawesome/free-solid-svg-icons";


const CostDriverDropDownManager = () => {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ costDriver: "", supportDocuments: "", defaultUnitPrice: "" });
  const [editId, setEditId] = useState(null);
  const [error, setError] = useState("");
  const theUserType = localStorage.getItem("userType");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
const [itemToDelete, setItemToDelete] = useState(null);
const [isLoading, setIsLoading] = useState(false);

  

  useEffect(() => {
    fetchList();
  }, []);

  const fetchList = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/CostDriverOptions`);

      if (Array.isArray(data)) {
        setItems(data);
      } else if (data && Array.isArray(data.$values)) {
        setItems(data.$values);
      } else {
        setItems([]);
        setError("Invalid data format received.");
      }

    } catch {
      setError("Failed to load cost drivers.");
    }
  };

  const clearForm = () => {
    setForm({ costDriver: "", supportDocuments: "", defaultUnitPrice: "" });
    setEditId(null);
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        setIsLoading(true);
        try{
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/CostDriverOptions/${editId}`, {
                id: editId,
                ...form
              });
        }finally{
            setIsLoading(false);
        }
        
      } else {
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CostDriverOptions`, form);
      }
      fetchList();
      clearForm();
    } catch {
      setError("Error saving cost driver.");
    }
  };

  const handleEdit = (item) => {
    setEditId(item.id);
    setForm({
      costDriver: item.costDriver,
      supportDocuments: item.supportDocuments,
      defaultUnitPrice: item.defaultUnitPrice || ""
    });
  };

  const handleConfirmDelete = async () => {
    setShowConfirmModal(false);    
    setIsLoading(true);            
  
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/CostDriverOptions/${itemToDelete}`);
      fetchList();                 
    } catch {
      setError("Delete failed.");
    } finally {
      setIsLoading(false);         
      setItemToDelete(null);       
    }
  };

  const handleCancelDelete = () => {
    setShowConfirmModal(false);
    setItemToDelete(null);
  };
  
  
  const handleDelete = (id) => {
    setItemToDelete(id);            
    setShowConfirmModal(true);      
  };
  

  return (

<div id="wrapper">
     <LoadingOverlay isVisible={isSubmitting} />
        
      <Sidebar userType={theUserType} />
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <button className="btn btn-link d-md-none rounded-circle mr-3" id="sidebarToggleTop">
              <i className="fa fa-bars"></i>
            </button>
            <ul className="navbar-nav ml-auto"><TopBarIcons /></ul>
          </nav>

          <div className="container-fluid">
            <div className="view-requisition-header">
              <Link to="/users" className="nav-link">
                <i className="fas fa-arrow-left back-button" />
              </Link>
            </div>    
            <h2>Cost Driver Dropdown Options</h2>
            <p>The Cost driver dropdown options can be managed from here:</p>

            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleSubmit} className="mb-3">
                <div className="form-row">
                <div className="col">
                    <input
                    type="text"
                    name="costDriver"
                    className="form-control"
                    placeholder="Cost Driver"
                    value={form.costDriver}
                    onChange={e => setForm({ ...form, costDriver: e.target.value })}
                    required
                    />
                </div>
                <div className="col">
                  <input
                    step="0.01"
                    name="defaultUnitPrice"
                    className="form-control"
                    placeholder="Default Unit Price"
                    value={form.defaultUnitPrice}
                    onChange={e =>
                      setForm({ ...form, defaultUnitPrice: e.target.value })
                    }
                    required
                  />
                </div>

                <div className="col">
                    <input
                    type="text"
                    name="supportDocuments"
                    className="form-control"
                    placeholder="Support Documents"
                    value={form.supportDocuments}
                    onChange={e => setForm({ ...form, supportDocuments: e.target.value })}
                    required
                    />
                </div>
                <div className="col-auto">
                    <button type="submit" className="btn btn-primary">
                    {editId ? "Update" : "Add"}
                    </button>
                    {editId && (
                    <button
                        type="button"
                        className="btn btn-secondary ml-2"
                        onClick={clearForm}
                    >
                        Cancel
                    </button>
                    )}
                </div>
                
                </div>
            </form>
            <table className="table table-striped">
                <thead>
                <tr>
                    <th>Cost Driver</th>
                    <th>Default Unit Price</th>
                    <th>Support Documents</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {items.map(item => (
                    <tr key={item.id}>
                    <td>{item.costDriver}</td>
                    <td>{item.defaultUnitPrice?.toLocaleString('en-US') || '-'}</td>
                    <td>{item.supportDocuments}</td>
                    <td>
                        <button className="btn btn-sm btn-warning mr-2" onClick={() => handleEdit(item)}>
                        Edit
                        </button>
                        <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item.id)}>
                        Delete
                        </button>
                    </td>
                    </tr>
                ))}
                {items.length === 0 && (
                    <tr><td colSpan="3">No cost drivers available.</td></tr>
                )}
                </tbody>
            </table>

            <ConfirmModal
            title="Are you sure you want to delete this item?"
            message="This action is permanent and cannot be undone."
            icon={faTrash}
            iconBorder="x-icon"
            isVisible={showConfirmModal}
            onConfirm={handleConfirmDelete}
            onCancel={handleCancelDelete}
            />

            <LoadingOverlay isVisible={isLoading} />

            <footer className="sticky-footer bg-white">
                <div className="container my-auto">
                    <div className="copyright text-center my-auto">
                    <span>Copyright © Farm Concern Internationalal 2025</span>
                    </div>
                </div>
            </footer>
            </div>
            
            </div>
        </div>

        
      
    </div>
  );
};

export default CostDriverDropDownManager;
